import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import {
  Button,
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
} from 'reactstrap';
import $ from 'jquery';
import { injectIntl } from 'react-intl';

import {
  setSelectedCollections,
  setSelectedAllCollections,
} from '../actions/Collections';
import {
  setSelectedFiles,
  setSelectedAllFiles,
} from '../actions/Files';

import {
  hideIntercomWidget,
  showIntercomWidget,
} from '../helpers';
import { isPageRoute } from '../helpers/PageSections';

import ActionbarWorkspaceActions from './ActionbarWorkspaceActions';
import ActionbarPageActions from './ActionbarPageActions';

class Actionbar extends PureComponent {
  constructor(props) {
    super(props);

    this.selectAllFiles = this.selectAllFiles.bind(this);
  }

  componentDidUpdate() {
    const {
      share,
      selectedCollections,
      selectedFiles,
    } = this.props;

    const moreElements = $('.actionbar .action-more .dropdown-menu button').length;
    if (moreElements > 0) {
      $('.actionbar .action-more').removeClass('hidden');
    } else {
      $('.actionbar .action-more').addClass('hidden');
    }

    if (!share) {
      return;
    }

    if (selectedCollections.length === 0 && selectedFiles.length === 0) {
      showIntercomWidget();
    } else {
      hideIntercomWidget();
    }
  }

  selectAllFiles() {
    const {
      files,
      selectFiles,
    } = this.props;

    selectFiles(files);
  }

  selectedItemsDescription() {
    const {
      intl,
      filesTotal,
      selectedFiles,
      selectedAllFiles,
      collectionsTotal,
      selectedCollections,
      selectedAllCollections,
    } = this.props;

    const totalSelectedFiles = selectedAllFiles ? filesTotal : selectedFiles.length;
    const totalSelectedCollections = selectedAllCollections ?
      collectionsTotal : selectedCollections.length;

    if (totalSelectedFiles === 0 && totalSelectedCollections === 0) {
      return null;
    }

    // const totalSelectedItems = totalSelectedFiles + totalSelectedCollections;
    const responseText = {
      collectionsText: totalSelectedCollections > 0 ? intl.formatMessage({
        defaultMessage: '{totalSelectedCollections} {totalSelectedCollections, plural, one {collection} other {collections}}',
      }, {
        totalSelectedCollections,
      }) : '',
      filesText: totalSelectedFiles > 0 ? intl.formatMessage({
        defaultMessage: '{totalSelectedFiles} {totalSelectedFiles, plural, one {file} other {files}}',
      }, {
        totalSelectedFiles,
      }) : '',
    };

    return intl.formatMessage({
      defaultMessage: 'Selected: {collectionsText}{count, plural, one {} other { and }}{filesText}',
    }, {
      collectionsText: responseText.collectionsText,
      filesText: responseText.filesText,
      count: (totalSelectedCollections > 0 && totalSelectedFiles > 0) ? 2 : 1,
    });
  }

  render() {
    const {
      intl,
      selectedFiles,
      selectedCollections,
      unselectAllFilesAndCollections,
      reorderingMode,
      filesTotal,
      collectionsTotal,
    } = this.props;
    const totalSelectedFiles = selectedFiles.length;
    const totalSelectedCollections = selectedCollections.length;

    const isPage = isPageRoute();

    if (reorderingMode) {
      return null;
    }

    return (
      <div
        className={classnames('actionbar', {
          active: totalSelectedFiles > 0 || totalSelectedCollections > 0,
        })}
      >
        <Container fluid>
          <Navbar className="navbar-expand">
            <div className="files-selected">
              <span className="files-selected-num">
                {this.selectedItemsDescription()}
              </span>
              {(totalSelectedFiles > 0 || totalSelectedCollections > 0) && (
                <span>
                  <Button
                    color="link"
                    className="files-unselect-all"
                    onClick={unselectAllFilesAndCollections}
                  >
                    {intl.formatMessage({ defaultMessage: 'Unselect all' })}
                  </Button>
                </span>
              )}
            </div>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={true} navbar className="nav-actions">
              {!isPage && <ActionbarWorkspaceActions />}
              {isPage && (
                <ActionbarPageActions
                  filesTotal={filesTotal}
                  collectionsTotal={collectionsTotal}
                />
              )}
            </Collapse>
          </Navbar>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  profile: state.Auth.profile,
  share: state.Shares.share,
  files: state.Files.files,
  filesTotal: props.filesTotal ?? state.Files.filesTotal,
  selectedFiles: state.Files.selectedFiles,
  selectedAllFiles: state.Files.selectedAllFiles,
  collectionsTotal: props.collectionsTotal ?? state.Collections.collectionsTotal,
  selectedCollections: state.Collections.selectedCollections,
  selectedAllCollections: state.Collections.selectedAllCollections,
  collection: state.Collections.collection,
  sidebarCollection: state.Collections.sidebarCollection,
  reorderingMode: state.Files.reorderingMode,
  collectionMoveModal: state.Collections.moveModalOpen,
});

const mapDispatchToProps = (dispatch) => ({
  selectFiles: (files) => {
    dispatch(setSelectedFiles(files));
  },
  unselectAllFiles: () => {
    dispatch(setSelectedFiles([]));
    dispatch(setSelectedAllFiles(false));
  },
  unselectAllCollections: () => {
    dispatch(setSelectedCollections([]));
    dispatch(setSelectedAllCollections(false));
  },
  unselectAllFilesAndCollections: () => {
    dispatch(setSelectedFiles([]));
    dispatch(setSelectedAllFiles(false));
    dispatch(setSelectedCollections([]));
    dispatch(setSelectedAllCollections(false));
  },
});

Actionbar.propTypes = {
  intl: PropTypes.object.isRequired,
  share: PropTypes.object,
  files: PropTypes.array.isRequired,
  filesTotal: PropTypes.number.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  selectedAllFiles: PropTypes.bool.isRequired,
  selectFiles: PropTypes.func.isRequired,
  collectionsTotal: PropTypes.number.isRequired,
  selectedCollections: PropTypes.array.isRequired,
  selectedAllCollections: PropTypes.bool.isRequired,
  unselectAllFilesAndCollections: PropTypes.func.isRequired,
  reorderingMode: PropTypes.bool.isRequired,
};

Actionbar.defaultProps = {
  share: null,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Actionbar));
